import _ from 'underscore';

import connectToRouter from 'js/lib/connectToRouter';

/* @ts-expect-error ts-migrate(7016) FIXME: Untyped import */
import mapExecuteActionToProps from 'js/lib/mapExecuteActionToProps';

import { savePost } from 'bundles/discussions/actions/ThreadDetailsActions';
import { clearThreadsCache } from 'bundles/discussions/actions/ThreadsActions';
import discussionsForumsHOC from 'bundles/discussions/components/discussionsForumsHOC';
import routerConnectToCurrentForum from 'bundles/discussions/utils/routerConnectToCurrentForum';

import ReplyCMLInput from './ReplyCMLInput';

export default _.compose(
  discussionsForumsHOC({ fields: ['link', 'title'] }),
  connectToRouter(routerConnectToCurrentForum),
  mapExecuteActionToProps((executeAction: $TSFixMe) => {
    return {
      handleSubmit: (post: $TSFixMe) => {
        executeAction(clearThreadsCache);
        executeAction(savePost, post);
      },
    };
  })
)(ReplyCMLInput);
